import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DialogTextSection = ({
  title,
  children,
  className
}) => /*#__PURE__*/_jsxs(TextSection, {
  className: className,
  children: [/*#__PURE__*/_jsx(Title, {
    children: title
  }), children]
});
const TextSection = styled.section.withConfig({
  displayName: "DialogTextSection__TextSection",
  componentId: "sc-vcoyac-0"
})(["display:flex;flex-direction:column;", "{margin-left:16px;margin-right:16px;}"], Viewports.for('small'));
const Title = styled.span.withConfig({
  displayName: "DialogTextSection__Title",
  componentId: "sc-vcoyac-1"
})(["color:", ";", ";line-height:36px;", "{", ";line-height:26px;}"], Colors.WHITE, Fonts.medium(24), Viewports.for('small'), Fonts.medium(20));